const contentUse = () => import("@/pages/content/use/index.vue");

export default [
    {
        path: "/content/use",
        component: contentUse,
        meta: [
            {
                name: "内容管理",
                activeRoute: "/content/manage",
            },
            {
                name: "使用政策",
                activeRoute: "/content/use",
            },
        ],
    },
];
